import { jsx as _jsx } from "react/jsx-runtime";
import { CpslText } from '@usecapsule/react-components';
import styled from 'styled-components';
export const UserIdentifier = ({ identifier }) => {
    return (_jsx(Container, { children: _jsx(IdentifierText, { variant: "bodyS", weight: "medium", children: identifier }) }));
};
const Container = styled.div `
  padding: 8px 16px;
  border-radius: 1000px;
  background-color: var(--cpsl-color-background-4);
`;
const IdentifierText = styled(CpslText) `
  --color-override: var(--cpsl-color-background-96);
`;
